import { Container } from "pixi.js";

export default class Camera {
  public stage: Container;
  public width: number;
  public height: number;
  constructor(stage: Container, width: number, height: number) {
    this.stage = stage;
    this.width = width;
    this.height = height;
  }

  reset() {
    this.stage = null as any;
    this.width = 0;
    this.height = 0;
  }
}
